import React, { useState, useEffect } from 'react'
import { InView } from 'react-intersection-observer'
import CountBadge from '../CountBadge/CountBadge'
import { pushEventAndTrack } from '../../helpers/taggingSerializer'
import { openAccordion } from '../../helpers/openAccordion'
import * as Styled from './GenericFlag.styles'

const getFlagData = (type, bundles, offers, offerBundles) => {
  switch (type) {
    case 'bundles':
      return {
        id: '#frequently-bought-together-accordion',
        eventName: 'pdp_reviewsFBTAnchor',
        eventInfo: 'Frequently bought together summary',
        title: 'View frequently bought together',
        dataLength: bundles.length
      }

    case 'offers':
      return {
        id: '#special-offers-accordion',
        eventName: 'pdp_reviewsSpecialOfferAnchor',
        eventInfo: 'special offers summary',
        title: `View special offer${offers.length > 1 ? 's' : ''}`,
        dataLength: offers.length
      }

    case 'moneyOffBundles':
      return {
        id: '#special-offers-accordion',
        eventName: 'pdp_moneyOffBundlesAnchor',
        eventInfo: 'Money Off Bundles Anchor Click',
        title: `Money off bundle${offerBundles.length > 1 ? 's' : ''}`,
        dataLength: offerBundles.length
      }

    default:
      return {
        id: '',
        eventName: '',
        eventInfo: '',
        title: '',
        dataLength: 0
      }
  }
}

const GenericFlag = ({ bundles = [], offers = [], offerBundles, productId = {}, type }) => {
  const [flagData, setFlagData] = useState(() => getFlagData(type, bundles, offers, offerBundles, productId))

  useEffect(() => {
    setFlagData(getFlagData(type, bundles, offers, offerBundles, productId))
  }, [productId])

  if (!flagData.dataLength) {
    return null
  }

  const handler = () => {
    openAccordion(flagData.id)
    pushEventAndTrack({
      eventInfo: {
        eventName: flagData.eventName,
        eventInfo: flagData.eventInfo
      }
    })
  }

  const onViewportChange = inView => {
    if (type === 'moneyOffBundles' && inView === true) {
      pushEventAndTrack({
        eventInfo: {
          eventName: 'pdp_moneyOffBundlesAnchorViewed',
          eventInfo: 'Money Off Bundle Anchor Viewed'
        }
      })
    }
  }

  return (
    <InView onChange={inView => onViewportChange(inView)} triggerOnce>
      <Styled.Flag
        className='top-border'
        onClick={handler}
        onKeyPress={handler}
        role='link'
        tabIndex='0'
        data-test={`generic-flag-${type}`}
      >
        <CountBadge items={flagData.dataLength} isFlag type={type} />
        <a>{flagData.title}</a>
      </Styled.Flag>
    </InView>
  )
}

export default GenericFlag
